// extracted by mini-css-extract-plugin
export default {"list":"passwordPolicy_list__nySju","bullet":"passwordPolicy_bullet__VOHkf"};